import { FC } from "react";
import { isMediaUrl } from "../utils";
import { CommentMediaGrid } from "../CommentMediaGrid";
import { CommentFileList } from "../CommentFileList";

interface CommentAttachmentsProps {
  attachments: string[];
  onAttachmentClick?: (url: string, allUrls: string[]) => void;
}

export const CommentAttachments: FC<CommentAttachmentsProps> = ({
  attachments,
  onAttachmentClick,
}) => {
  if (attachments.length === 0) return null;

  const allMedia = attachments.every(isMediaUrl);

  if (allMedia) {
    return (
      <CommentMediaGrid
        attachments={attachments}
        onAttachmentClick={onAttachmentClick}
      />
    );
  }

  return (
    <CommentFileList
      attachments={attachments}
      onAttachmentClick={onAttachmentClick}
    />
  );
};
